import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=2305ac41&scoped=true&"
var script = {}
import style0 from "./NavBar.vue?vue&type=style&index=0&id=2305ac41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2305ac41",
  null
  
)

export default component.exports